import { Sidebar, SidebarContent, SidebarSeparator } from "@/components/ui/sidebar";
import Header from "./Header";
import NavigationSection from "./NavigationSection";
import Footer from "./Footer";
import ConversationsHistorySection from "./ConversationsHistorySection";

const AppBarLayout = ({ ...props }: React.ComponentProps<typeof Sidebar>) => {
  return (
    <Sidebar collapsible="none" side="right" {...props}>
      <Header />
      <SidebarContent className="min-h-0 flex-1">
        <div className="flex-shrink-0">
          <NavigationSection />
        </div>
        <div className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto">
          <ConversationsHistorySection />
        </div>
      </SidebarContent>
      <SidebarSeparator className="shrink-0" />
      <Footer />
    </Sidebar>
  );
};

export default AppBarLayout;
